import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { AssignmentQuestionTypesEnum } from '@school_ify/schoolify-repository/src/shared/types';

import QuizQuestionTypeOption from '../QuizQuestionTypeOption/QuizQuestionTypeOption';

import './QuizQuestionTypeOptionCollection.scoped.scss';

interface Props {
  quizId: string;
}

const QuizQuestionTypeOptionCollection = (props: Props) => {
  const { quizId } = props;
  const history = useHistory();
  const { t } = useTranslation();

  const questionTypeOptions = [
    {
      id: '1',
      name: t('quiz:QuestionTypes.OneOrMore'),
      alias: t('quiz:QuestionTypes.OneOrMoreAlias'),
      path: '/quiz/multiple-option',
      imagePath: `${process.env.PUBLIC_URL}/assets/icons/pick-one-or-more.svg`,
      type: AssignmentQuestionTypesEnum.PICK_OPTIONS,
    },
    {
      id: '2',
      name: t('quiz:QuestionTypes.FillBlank'),
      alias: t('quiz:QuestionTypes.FillBlankAlias'),
      path: '/quiz/blank-form',
      imagePath: `${process.env.PUBLIC_URL}/assets/icons/fill-in-blank.svg`,
      type: AssignmentQuestionTypesEnum.FILL_IN_BLANK,
    },
    // {
    //   id: '3',
    //   name: t('quiz:QuestionTypes.Matching'),
    //   alias: t('quiz:QuestionTypes.MatchingAlias'),
    //   path: '/quiz/matching',
    //   imagePath: '/assets/icons/matching.svg',
    //   type: AssignmentQuestionTypesEnum.MATCHING,
    // },
    {
      id: '4',
      name: t('quiz:QuestionTypes.OpenQuestion'),
      alias: t('quiz:QuestionTypes.OpenQuestionAlias'),
      path: '/quiz/open-question',
      imagePath: `${process.env.PUBLIC_URL}/assets/icons/open-question.svg`,
      type: AssignmentQuestionTypesEnum.OPEN_QUESTION,
    },
  ];

  return (
    <div className="new-quiz-question-wrapper">
      <div className="new-quiz-question">
        <p className="new-quiz-question-description">{t('quiz:QuestionTypes.Select')}</p>

        <div className="quiz-question-types">
          {questionTypeOptions?.map(questionType => (
            <QuizQuestionTypeOption
              key={questionType.id}
              questionType={questionType}
              onClick={() => history.push(`/quiz/questions/new/${questionType.type}/${quizId}`)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default QuizQuestionTypeOptionCollection;
